/**
 * Created by simon zhao on 9/19/2022.
 * Description:
 * Model NoteDepositTriggerMetaDialog declaration.
 * ------ maintenance history ------
 */
import { KeyValue } from '@angular/common';
import { AdhocWorkflowField } from '../../../../tamalelibs/models/adhoc-field.model';
import { AutomationMappingItem } from '../../../../tamalelibs/models/automation.model';
import { ControlType } from '../../../../tamalelibs/models/template-control.model';
import { MultiSelDropdownFilterConfig } from '../../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import * as _lodash from 'lodash';
import { COMMON_DELIMITER } from '../../../../tamalelibs/services/array-helper.service';
export class NoteDepositMappingItemViewModel {

    applicableFieldTypes: Array<ControlType> = [];

    applicableSystemVariables: Array<KeyValue<string, string>> = [];

    /**
    * A function being called when a template field is clicked.
    */
    click?: (field: NoteDepositMappingItemViewModel) => void;

    /**
     * the data source of field candidates for single selection.
     */
    dataSourceForSingleSelection?: Array<KeyValue<string, string>>;

    /**
    * the data source of field candiates for multiple selection.
    */
    dataSourceForMultipleSelection?: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();

    /**
     * the source field, key --- the field label, value ---- the field id.
     */
    fieldInTemplate: string;

    /**
     * the mapping target fields.
     */
    fieldsInWorkflow: KeyValue<string, string> | Array<KeyValue<string, string>>;

    /**
    * a flag indicating whether current mapping item is deletable.
    */
    isDeletable: boolean;

    /**
     * a flag indicating whether current mapping should be loaded defaultly.
     */
    isPreloaded: boolean;


    /**
     * a flag indicating whether a multiple selection control should generate for this item.
     */
    isMultipleSelection: boolean;

    nameOfFieldInTemplate: string;

    static toAutomationItem(src: NoteDepositMappingItemViewModel) {
        const result = new AutomationMappingItem();
        const extractFieldsInWorkflowFunc = () => {
            if (src.isMultipleSelection) {
                return src.dataSourceForMultipleSelection.data.filter(fItem => fItem.checked).map(r => r.id).join(COMMON_DELIMITER);
            } else {
                return Array.isArray(src.fieldsInWorkflow) ? src.fieldsInWorkflow.map(f => f.value).join(COMMON_DELIMITER) : src.fieldsInWorkflow.value;
            }
        };
        result.fieldInTemplate = src.fieldInTemplate;
        result.fieldInWorkflow = extractFieldsInWorkflowFunc();
        return result;
    }
}

export class NoteDepositTriggerMetaDialogOptions {
    existingMapping?: Array<AutomationMappingItem>;
    noteTypeAdhocFields: Array<AdhocWorkflowField>;
    isUpdate: boolean;
    static toViewModelArray(options: NoteDepositTriggerMetaDialogOptions, references: Array<NoteDepositMappingItemViewModel>): Array<NoteDepositMappingItemViewModel> {
        const vmArray = [];
        if (options && options.isUpdate && options.existingMapping) {
            options.existingMapping.forEach(
                it => {
                    const vm = new NoteDepositMappingItemViewModel();
                    vm.fieldInTemplate = it.fieldInTemplate;
                    const refVm = references.find(refIt => refIt.fieldInTemplate === vm.fieldInTemplate);
                    if (refVm) {
                        const singleDs = _lodash.cloneDeep(refVm.dataSourceForSingleSelection);
                        const multipleDs = _lodash.cloneDeep(refVm.dataSourceForMultipleSelection);
                        const extractFieldNameFunc = (id: string) => {
                            if (refVm.dataSourceForSingleSelection && refVm.dataSourceForSingleSelection.length > 0) {
                                return refVm.dataSourceForSingleSelection.find(vmItem => vmItem.value === id);
                            }

                            return null;
                        };
                        const emptyKVPair = {key: '', value: ''};
                        if (refVm.isMultipleSelection) {
                            const matchKVPairs = [];
                            it.fieldInWorkflow.split(COMMON_DELIMITER).forEach(fldId => {
                                const matchKS = extractFieldNameFunc(fldId);
                                if (matchKS) {
                                    matchKVPairs.push(matchKS);
                                    const matchDsItem = multipleDs.data.find(f => f.id === matchKS.value);
                                    if (matchDsItem) {
                                        matchDsItem.checked = true;
                                    }
                                } else {
                                    matchKVPairs.push(emptyKVPair);
                                }
                            });

                            vm.fieldsInWorkflow = matchKVPairs;
                        } else {
                            const matchRef = extractFieldNameFunc(it.fieldInWorkflow);
                            if (matchRef) {
                                vm.fieldsInWorkflow = extractFieldNameFunc(it.fieldInWorkflow);
                            } else {
                                // the reference field maybe deleted.
                                vm.fieldsInWorkflow = emptyKVPair;
                            }
                        }
                        vm.applicableFieldTypes = refVm.applicableFieldTypes;
                        vm.dataSourceForSingleSelection = singleDs;
                        vm.dataSourceForMultipleSelection = multipleDs;
                        vm.isMultipleSelection = refVm.isMultipleSelection;
                        vm.isDeletable = refVm.isDeletable;
                        vm.isPreloaded = refVm.isPreloaded;
                        vm.nameOfFieldInTemplate = refVm.nameOfFieldInTemplate;
                    } else {
                        // the template field might be deleted
                        // empty it so that this row would be recognized as an invalid record and warn users.
                        vm.fieldInTemplate = '';
                    }

                    vmArray.push(vm);
                }
            );
        }

        return vmArray;
    }
}

export class NoteDepositTriggerMetaDialogResult {
    isConfirmed: boolean;
    mappingResult: Array<AutomationMappingItem>;
    isUpdate: boolean;
}
